export enum EtatPalette {
    PRETE = "PRETE",
    EXPEDIEE = "EXPEDIEE",
    EN_PREPARATION = "EN_PREPARATION",
}

